import { useState, useEffect } from 'react';
import { contentService, SiteContent } from '../services/contentService';

export function useSiteContent(pageType: string) {
  const [content, setContent] = useState<SiteContent | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadContent = async () => {
      try {
        setLoading(true);
        const data = await contentService.getPublishedContent(pageType);
        setContent(data);
      } catch (err) {
        setError('加载内容失败');
        console.error('Error loading content:', err);
      } finally {
        setLoading(false);
      }
    };

    loadContent();
  }, [pageType]);

  return { content, loading, error };
}

export function useSiteConfig(key: string) {
  const [value, setValue] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadConfig = async () => {
      const data = await contentService.getConfig(key);
      setValue(data);
      setLoading(false);
    };

    loadConfig();
  }, [key]);

  return { value, loading };
}
